import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetSearchResultsPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import {FilterAndSortFABView} from '../../../features/Filters/FilterAndSort/FilterAndSortFABView';
import {useSearchPageFiltersSection} from '../hooks/useSearchPageBulkSection';

export const SearchStreamFilterButton: React.FC<PriorityConfig> = props => (
  <DataFetcher
    request={useSearchPageFiltersSection()}
    Error={null}
    View={FilterAndSortView}
    viewProps={props}
    renderingPriority={props.renderingPriority}
  />
);

const FilterAndSortView: React.FC<
  GetSearchResultsPageBulkResponse['filters']
> = ({appliedFiltersCount}) => {
  const {t} = useTranslation();

  return (
    <FilterAndSortFABView count={appliedFiltersCount} label={t('Filter')} />
  );
};
